export enum GalleryDataTestId {
  GALLERY_IMAGE = 'gallery-image--gallery-component',
}
